<template>
  <div class="singleObjectBiddings pt-50" v-if="currentListingWithBids">
    <HeaderNavigation v-bind:title="currentListingWithBids.address"/>
    <div class="container pt-75">

      <!-- pris -->

      <ul class="home-links object-info">
        <li>
          <span>Utgångspris</span>
          <span class="bold mt-5" v-show="currentListingWithBids.price">{{ $root.formatPrice(currentListingWithBids.price) }} kr</span>
          <span class="bold mt-5 opaque-60" v-show="!currentListingWithBids.price">saknas</span>
        </li>
        <li>
          <span>Högsta bud</span>
          <span class="bold mt-5" v-show="currentListingWithBids.maxBid">{{ $root.formatPrice(currentListingWithBids.maxBid) }} kr</span>
          <span class="bold mt-5 opaque-60" v-show="!currentListingWithBids.maxBid">saknas</span>
        </li>
      </ul>

      <!--- säljare sms:a / maila alla säljare -->

      <div class="grid2col mt-35 mb-15">
        <div class="all-caps">Säljare</div>
        <div class="flex justify-between"><img alt="sms-multi"  class="ml-50" @click="sms('sellers')" src="../assets/icons/sms_multi.svg"><img alt="mail-multi" src="../assets/icons/mail_multi.svg"  @click="mail('sellers')" class="mr-15"></div>
      </div>

      <!-- säljare -->
      <ul>
        <li class="p15 bg-white mb-2 shadow" v-for="seller in currentListingWithBids.sellers" v-bind:key="seller.id">
          <div class="grid2col">
            <div>{{ seller.firstname }} {{ seller.lastname }}</div>
            <div class="flex justify-between"><a :href="`tel:${seller.cellphone ? seller.cellphone : seller.phone}`"><img alt="icon" src="../assets/icons/phone.svg"></a><img alt="icon" src="../assets/icons/sms.svg" @click="sms(seller)"><img alt="icon" src="../assets/icons/mail.svg" @click="mail(seller)"> </div>
          </div>
          <div v-if="seller.subcustomers" class="mt-20">
            <div class="grid2col mb-15" v-for="(contactperson, index) in seller.subcustomers" :key="index">
              <div class="fs-14">{{ contactperson.firstname }} {{ contactperson.lastname }}</div>
              <div class="flex justify-between"><a :href="`tel:${contactperson.cellphone ? contactperson.cellphone : contactperson.phone}`"><img alt="icon" src="../assets/icons/phone.svg"></a><img alt="icon" src="../assets/icons/sms.svg" @click="sms(contactperson)"><img alt="icon" src="../assets/icons/mail.svg" @click="mail(contactperson)"> </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- budgivning -->
      <p class="mt-35 mb-15 all-caps">Budgivning <img v-if="isSecureBid" class="ml-5" style="width: 103px;" src="../assets/icons/securebidslogo.svg"></p>
      <button class="width-100 outline" @click="newBidder">ny budgivare</button>
      <div class="flex justify-between all-caps mt-15 mb-30">
        <span @click="bidHistory" class="fg-primary">budhistorik</span>
        <span @click="receivers" class="fg-primary">mottagare</span>
        <span @click="settings" class="fg-primary">inställningar</span>
      </div>

      <!-- budgivare -->
      <tip v-if="currentListingWithBids" id="expand-card" title="Expandera kort" body="Tryck på kort för att visa mer information.<br>Tryck igen för att dölja."></tip>
      <div v-if="currentListingWithBids && listingBidders">
        <card v-for="bidder in listingBidders" v-bind:key="bidder.id">
          <div class="grid2col">
            <div>Budgivare {{ bidder.bidder }} <span v-if="bidder.stopped" class="bold fg-red ml-5">stannat</span><br>
              <template v-if="bidder.stakeholderGroup !== null">
                <span class="fs-14" v-for="(stakeholder, index) in bidder.stakeholderGroup.stakeholders" v-bind:key="index">
                <span class="opaque-60">{{ stakeholder.customer.firstname}} {{ stakeholder.customer.lastname}}</span> <img v-if="isSecureBid" alt="securebid status" class="securebid-status" v-bind:src="testarsig(stakeholder.customer.activityBidVerified)"/><i v-show="index != bidder.stakeholderGroup.stakeholders.length -1">, </i>
                </span>
              </template>

            </div>
            <div class="text-right" v-for="(bid, index) in bidder.bids" :key="index">
              <div v-if="index === 0">
                {{ $root.formatPrice(bid.amount) }} kr<br><span class="fs-14 opaque-60">{{ dateWithoutSeconds(bid.date) }}</span>
              </div>
            </div>
          </div>

          <div class="flex justify-between mt-15">
            <div class="flex-basis-50 align-middle">
              <template v-if="bidder.stakeholderGroup !== null">
                <div class="flex justify-between" v-for="(stakeholder, index) in bidder.stakeholderGroup.stakeholders" v-bind:key="index">
                  <!-- there is only one stakeholder -->
                  <a v-if="bidder.stakeholderGroup.stakeholders.length === 1" @click.stop="call(stakeholder.customer.cellphone ? stakeholder.customer.cellphone : stakeholder.customer.phone)"><img alt="icon" src="../assets/icons/phone.svg" class="mr-40"></a>
                  <img v-if="bidder.stakeholderGroup.stakeholders.length === 1" alt="icon" src="../assets/icons/sms.svg" class="mr-40" @click.stop="sms(stakeholder.customer)">
                  <img v-if="bidder.stakeholderGroup.stakeholders.length === 1" alt="icon" src="../assets/icons/mail.svg" class="mr-40" @click.stop="mail(stakeholder.customer)">
                  <!-- if multiple stakeholders -->
                  <div v-if="bidder.stakeholderGroup.stakeholders.length > 1 && index === 0">
                    <img alt="icon" src="../assets/icons/phone.svg" class="mr-40" @click.stop="multiCall(xtract(bidder.stakeholderGroup.stakeholders))">
                    <img alt="icon" src="../assets/icons/sms_multi.svg" class="mr-40" @click.stop="sms('bidders', xtract(bidder.stakeholderGroup.stakeholders))">
                    <img alt="icon" src="../assets/icons/mail_multi.svg" class="mr-40" @click.stop="mail('bidders', xtract(bidder.stakeholderGroup.stakeholders))">
                  </div>
                </div>
              </template>

            </div>
            <div>
              <span class="all-caps fg-primary select-none" v-if="!bidder.stopped" @click.stop="newBid(bidder)">nytt bud</span>
              <span class="all-caps fg-primary select-none" v-if="bidder.stopped" @click.stop="resumeBidding(bidder.id)">återuppta</span>
            </div>
          </div>

          <div class="mb-15 grid2col mt-20 card__collapsed pt-5" v-if="smsBidsAllowed">
            <div>
              <label class="switch mr-10">
                <input type="checkbox" class="mr-5" @change="setBidBySms(bidder)" v-model="bidder.bidBySmsActive">
                <div class="slider round"></div>
              </label>
              <span>SMS-bud</span>
            </div>
            <div class="text-right all-caps fg-primary select-none">
              <span @click="resend(bidder)">återskicka</span>
            </div>
          </div>

          <div class="bidhistory" v-if="bidder.bids && bidder.bids.length">
            <p class="all-caps mt-25 fs-14 mb-10">budhistorik</p>
            <div class="grid3col grid3col--history mb-10" v-for="(bid, index) in bidder.bids"  :key="index">
              <div :class="{ strikeThrough : bid.deleted }">
                <img alt="icon" class="bid-blocked mr-5" src="../assets/icons/blocked.svg" v-show="bid.hide">
                <img alt="icon" class="bid-blocked mr-5" src="../assets/icons/globe-lock.svg" v-show="!bid.confirmedForPublish">
                {{ $root.formatPrice(bid.amount) }} kr
              </div>
              <div :class="{ strikeThrough : bid.deleted }" class="text-center"><span class="opaque-60">{{ dateWithoutSeconds(bid.date) }}</span></div>
              <div v-show="!bid.deleted" class="text-right"><img alt="icon" src="../assets/icons/pen.svg" @click.stop="editBid(bid, bidder.bidder)"></div>
            </div>
            <span class="all-caps fg-primary fs-16 mt-35 flex-inline" v-if="!bidder.stopped" @click.stop="stopBid(bidder.id)">stanna</span>
          </div>
        </card>
      </div>

      <!-- intressenter -->
      <p class="mt-35 mb-15 all-caps">intressenter</p>
      <div v-for="(stakeholderGroup, index) in stakeHolders" :key="index" class="mt-15 relative stakeholders">
        <div v-if="stakeholderGroup.stakeholders.length">
          <div @click="editPrio(stakeholderGroup)" class="prio-wrap shadow"><i class="prio-icon flex-inline" :class="prioClass(stakeholderGroup)"></i></div>
          <biddingsstakeholdercard class="mb-0" v-for="(stakeholder, index) in stakeholderGroup.stakeholders" :key="index" v-bind:stakeholder="stakeholder" v-bind:stakeholdergroup="stakeholderGroup">
            <div class="grid2col">
              <div class="select-none pl-15" :class="{ strikeThrough : stakeholderGroup.deleted }">{{ stakeholder.customer.firstname }} {{ stakeholder.customer.lastname }}</div>
              <div class="flex justify-between">
                <a :href="`tel:${stakeholder.customer.cellphone ? stakeholder.customer.cellphone : stakeholder.customer.phone  }`">
                  <img alt="icon" src="../assets/icons/phone.svg">
                </a>
                <img alt="icon" src="../assets/icons/sms.svg" @click="sms(stakeholder.customer)">
                <img alt="icon" src="../assets/icons/mail.svg" @click="mail(stakeholder.customer)">
              </div>
            </div>
          </biddingsstakeholdercard>
        </div>
      </div>


    </div>
    <Modal>
      <component v-bind:is="activeComponent" @submitted="this.setModalComponent"/>
    </Modal>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import HeaderNavigation from '@/components/HeaderNavigation';
import Modal from '../components/Modal';
import card from '../components/card';
import biddingsstakeholdercard from '../components/biddingsStakeholderCard';
import tip from  '../components/Tip';

// forms
import newBidder from '../components/forms/budgivning/newBidder';
import bidSettings from '../components/forms/budgivning/bidSettings';
import stopBid from '../components/forms/budgivning/stopBid';
import newBid from '../components/forms/budgivning/newBid';
import sendSmsOrMail from '../components/forms/generic/sendSmsOrMail';
import bidHistory from '../components/forms/budgivning/bidHistory';
import receivers from '../components/forms/budgivning/receivers';
import editPrio from '../components/forms/budgivning/editPrio';
import multiCall from '../components/forms/budgivning/multiCall';
import editBid from '../components/forms/budgivning/editBid';
import deleteBid from '../components/forms/budgivning/deleteBid';
import _ from 'lodash';

export default {
  name: 'SingleObjectBidding',
  data() {
    return {
      activeComponent: ''
    }
  },
  computed: {
    smsBidsAllowed() {
      return this.$store.state.currentListingWithBiddings.bidSettings.bySms;
    },
    // Sort bidders by latest bid date
    listingBidders() {
      return _.orderBy(this.currentListingWithBids.bidIdentities, (item) =>  {
        if (item.bids === null) {
          return false;
        }
        return item.bids[0].date
      }, ['desc']);
    },
    isSecureBid() {
      return this.$store.state.currentListingWithBiddings.bidSettings.secureBid;
    },
    currentListingWithBids() {
      return this.$store.getters.getCurrentActiveListing;
    },
    stakeHolders() {
      return  _.orderBy(this.$store.state.currentListingWithBiddings.stakeholderGroups, ['deleted','priority'], ['asc', 'desc']);
    }
  },
  components: {
    HeaderNavigation,
    Footer,
    Modal,
    card,
    biddingsstakeholdercard,
    tip,

    // Forms
    newBidder,
    bidSettings,
    stopBid,
    newBid,
    sendSmsOrMail,
    bidHistory,
    editPrio,
    multiCall,
    editBid,
    deleteBid
  },
  methods: {
    testarsig(verified){
      if (verified.bankIdUsage) {
        return require("@/assets/icons/shield-green.svg");
      } else if (verified.manuallyVerified) {
        return require("@/assets/icons/shield-yellow.svg");
      } else {
        return require("@/assets/icons/shield-grey.svg");
      }
    },
    dateWithoutSeconds(date) {
      return date.slice(0, -3);
    },
    /**
     * Resend sms CODE to bidder
     */
    resend(bidder) {

      let confirm = window.confirm("Vill du skicka SMS-koden till SMS-budgivaren?");
      if (!confirm) {
        return false;
      }

      let data = {
        objectId: this.$route.params.id,
        bidIdentity: bidder.id
      };
      this.$root.callFasAdApi("/internalapi/bid/resend-sms-code", "POST", data)
      .then((data) => {
        this.$root.handleResponseMessage(data, "SMS skickat!");
      })
      .catch(console.error);
    },
    /**
     * Saves if this bidder should be able to send bid by sms or not
     */
    setBidBySms(bidder) {

      let data = {
        objectId: this.$route.params.id,
        bidIdentity: bidder.id,
        active: bidder.bidBySmsActive ? 1 : 0
      }
      this.$root.callFasAdApi("/internalapi/bid/sms-bidding", "POST", data)
      .then((data) => {
        console.log(data);
      })
      .catch(console.error);
    },
    editBid(bid, bidderId) {
      bid.bidderId = bidderId;
      this.$store.commit('SET_EDIT_BID', bid);
      this.activeComponent = editBid;
      this.showModal();
    },
    multiCall(stakeholders) {
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', stakeholders);
      this.activeComponent = multiCall;
      this.showModal();
    },
    /**
     *  Ugly but needed for now due to the structure of response from api
     */
    xtract(holders) {
      let extracted = [];
      holders.forEach((holder) => {
        extracted.push(holder.customer);
      });
      return extracted;
    },
    /**
     * Only needed because call buttons using this call function
     * is inside a collapsible card so we need to stop event bubbling.
     */
    call(number) {
      document.location.href = "tel:"+ number;
    },
    editPrio(stakeholdergroup) {
      this.activeComponent = editPrio;
      this.$root.modalOpen = true;
      this.$store.commit("SET_EDIT_PRIO", stakeholdergroup);
    },
    /**
     * Return proper classes based upon prio from 0-6
     */
    prioClass(prio) {
      if (prio.deleted) {
        return "icon-prio-filled-red"
      }
      switch(prio.priority) {
        case 6:
          return "icon-prio-star icon--orange"
        case 5:
          return "icon-prio-star icon--blue"
        case 4:
          return "icon-prio-filled"
        case 3:
          return "icon-prio-three-quarters"
        case 2:
          return "icon-prio-half"
        case 1:
          return "icon-prio-one-quarter"
        default:
          return "icon-prio-reset"
      }
    },

    /**
     * Function that will set modal content dynamically - triggered
     * by the emittion of the "submitted" event.
     */
    setModalComponent(value){
      this.$root.modalOpen = false;
      this.activeComponent = value.component;

      // too fast, adding a timeout ¯\_(ツ)_/¯
      setTimeout(() => {
        this.$root.modalOpen = true;
      }, 250)
    },
    showModal() {
      this.$root.modalOpen = true;
    },
    newBidder() {
      if (this.isSecureBid) {
        alert("Säkra bud är aktivt\n\nDu kan endast lägga till ny budgivare genom FasAd desktop version.");
        return  false;
      }
      this.activeComponent = newBidder;
      this.showModal();
    },
    newBid(bidder) {
      this.storeUserData(bidder);
      this.activeComponent = newBid;
      this.showModal();
    },
    storeUserData(bidder) {
      let bidData = {
        bidIdentity: bidder,
        objectId: this.$route.params.id
      };

      // Double checking...
      if (!bidData.bidIdentity || !bidData.objectId) {
        alert('Någonting gick fel. Felkod: 1001'); // unable to store bidder ID or objectId
        return false;
      }

      // Store object with info we need to handle one single bidder
      this.$store.commit('STORE_CURRENT_USER_DATA', bidData);
    },
    bidHistory() {
      this.activeComponent = bidHistory;
      this.showModal();
    },
    stopBid(bidder) {
      this.storeUserData(bidder);
      this.activeComponent = stopBid;
      this.showModal();
    },
    resumeBidding(bidderId) {
      let data = {
        bidIdentity: bidderId,
        objectId: this.$route.params.id
      };

      this.$root.callFasAdApi("/internalapi/bid/resume-bid-identity/", "POST", data)
      .then(() => {
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
      })
      .catch(console.error);
    },
    receivers(){
      this.activeComponent = receivers;
      this.showModal();
    },
    settings() {
      this.activeComponent = bidSettings;
      this.showModal();
    },
    mail(data, bidders) {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'bidding');
      let receiverData = {
        deliveryWay: "email",
        receivers : [],
        subject: '',
        message: ''
      };
      // handle mail ALL sellers or bidders
      if (data === "sellers") {
        receiverData.receivers = this.$store.getters.getSellersAndExtraContactPersons;
      } else if (data === "bidders") {
        receiverData.receivers = bidders;
      } else {
        receiverData.receivers.push(data);
      }
      this.$store.commit('STORE_SEND_SMS_OR_MAIL_CONTACT_DATA', receiverData);

      this.activeComponent = sendSmsOrMail;
      this.$root.modalOpen = true;
    },
    sms(data, bidders) {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'bidding');
      let receiverData = {
        deliveryWay: "sms",
        receivers : []
      };

      // handle sms ALL sellers, or bidders
      if (data === "sellers") {
        receiverData.receivers = this.$store.getters.getSellersAndExtraContactPersons;
      } else if (data === "bidders") {
        receiverData.receivers = bidders;
      }
      else {
        receiverData.receivers.push(data);
      }
      this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', 'sms');
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', receiverData.receivers);

      this.activeComponent = sendSmsOrMail;
      this.$root.modalOpen = true;
    },
  },
  created() {
    this.$store.dispatch('storeCurrentUserMessagingTemplates');
    this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
    this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
  }
}
</script>

<style>
.bid-blocked {
  position: relative;
  top: 1px;
}
.object-info li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.stakeholders .prio-wrap {
  position: absolute;
  left: -5px;
  top: 0;
  padding: 5px 5px 2px;
  background-color: white;
}
.securebid-status {
  margin-left:2px;
  position: relative;
  top:2px;
}
</style>
